import { Mail, UserX } from "lucide-react";

import { OrgEmployee } from "../model/teamHierachyModel";

const getInitials = (name: string) =>
  name
    .split(" ")
    .map((w) => w[0]?.toUpperCase())
    .join("")
    .slice(0, 2);

const roleBadgeClass: Record<string, string> = {
  RECRUITER: "bg-green-100 text-green-700",
  VIEWER: "bg-gray-100 text-gray-600",
};

const UnassignedList = ({ employees }: { employees: OrgEmployee[] }) => {
  if (!employees.length) return null;

  return (
    <div className="mt-12 mx-auto max-w-2xl">
      <div className="flex items-center gap-2 mb-4">
        <UserX size={18} className="text-muted-foreground" />
        <h2 className="text-lg font-semibold text-foreground">
          Unassigned ({employees.length})
        </h2>
      </div>
      <div className="grid gap-2 grid-cols-1 sm:grid-cols-2">
        {employees.map((emp) => (
          <div
            key={emp.id}
            className="flex items-center gap-3 rounded-lg border-2 border-dashed border-black-400 bg-gray-50 px-4 py-3"
          >
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-300 text-xs font-bold text-gray-700">
              {getInitials(emp.full_name)}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium capitalize text-black truncate">
                {emp.full_name}
              </p>
              <p className="text-xs text-muted-foreground truncate flex items-center gap-1">
                <Mail size={10} /> {emp.email}
              </p>
            </div>
            <span
              className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-medium  ${
                roleBadgeClass[emp.role] || roleBadgeClass.VIEWER
              }`}
            >
              {emp.role}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UnassignedList;
